import React from 'react';

const BrandLogo = ({ showText = false, sizeClass = 'h-10' }) => {
  return (
    <div className="flex items-center gap-2">
      <img
        src={process.env.PUBLIC_URL + '/brand/edited-photo.png'}
        alt="LinkDash"
        className={`${sizeClass} w-auto`}
      />
      {showText && (
        <span className="text-2xl font-bold text-white">
          <span className="text-primary">Link</span>Dash
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
